import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as actionsUi from './mandanten-auswahl.actions.ui';
import {
    GET_MEINE_MANDANTEN,
    GET_MEINE_MANDANTEN_ERFOLGREICH,
    GET_MEINE_MANDANTEN_FEHLER,
    GetMeineMandantenAction,
    GetMeineMandantenErfolgreichAction,
    GetMeineMandantenFehlerAction
} from '../../../client-ngrx/api';
import {MandantInfo} from '../../../clients/api';
import {MANDANT_SETZEN, MandantSetzenAction} from '@orga-app/mandant/actions';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';

export const MandantAuwahlFeature = 'MandantenAuswahlPage';

export interface ModuleState {
    mandantAuswahl: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    mandantAuswahl: mandantAuswahlReducer
};

export interface PageState {
    mandanten: Array<MandantInfo>;
    mandantenLaden: boolean;
    mandantenFehler: boolean;
    mandant: MandantInfo;
}

export const initialPageState: PageState = {
    mandanten: [],
    mandantenLaden: false,
    mandantenFehler: false,
    mandant: null
};

export function mandantAuswahlReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState>initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            const a = <actionsUi.PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Meine Mandanten
        case GET_MEINE_MANDANTEN: {
            const a = <GetMeineMandantenAction> action;
            return Object.assign({}, state, <PageState> {
                mandantenLaden: true
            });
        }
        case GET_MEINE_MANDANTEN_ERFOLGREICH: {
            const a = <GetMeineMandantenErfolgreichAction> action;

            return Object.assign({}, state, <PageState> {
                mandanten: a.payload,
                mandantenLaden: false,
                mandantenFehler: false
            });
        }
        case GET_MEINE_MANDANTEN_FEHLER: {
            const a = <GetMeineMandantenFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                mandantenLaden: false,
                mandantenFehler: true
            });
        }

        // Mandant setzen
        case MANDANT_SETZEN: {
            const a = <MandantSetzenAction> action;

            return Object.assign({}, state, <PageState> {mandant: a.mandant});
        }

        default: {
            return state;
        }
    }
}

export const getModuleState = createFeatureSelector<ModuleState>(MandantAuwahlFeature);

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.mandantAuswahl);

export const getMandanten = createSelector(getPageState, (state: PageState) => {
    const mandanten = [...state.mandanten];
    return mandanten.sort((a, b) => {
        if (a.beschreibung.toLowerCase() < b.beschreibung.toLowerCase()) {
            return -1;
        }
        if (a.beschreibung.toLowerCase() > b.beschreibung.toLowerCase()) {
            return 1;
        }
        return 0;
    });
});

export const getMandantenLaden = createSelector(getPageState, (state: PageState) => state.mandantenLaden);

export const getMandantenFehler = createSelector(getPageState, (state: PageState) => state.mandantenFehler);

export const getMandant = createSelector(getPageState, (state: PageState) => state.mandant);
